import { render } from "./AttributeForm.vue?vue&type=template&id=10ba4079"
import script from "./AttributeForm.vue?vue&type=script&lang=js"
export * from "./AttributeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__